// DEC-006: rutas MFA separadas en grupo público y autenticado. Ver DECISIONES.md.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MfaMethodChooser } from '../components/auth/MfaMethodChooser';

const schema = z.object({ session: z.string().min(1) });

export const Route = createFileRoute('/login/mfa-setup')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    component: MfaSetupRoute,
});

function MfaSetupRoute() {
    const { session } = Route.useSearch();
    // AuthLayout lo provee el parent /login vía <Outlet />.
    return <MfaMethodChooser session={session} />;
}
